import { useQuery } from '@tanstack/react-query';
import { SubmissionStatus } from '@common/types';
import { IProductSubmissionStatusDto } from '@common/services/types';
import { fetchProductSubmissionStatuses } from '@common/services/productService';

interface UseActiveSubmissionsResult {
  activeSubmissions: IProductSubmissionStatusDto[];
  hasActiveSubmission: boolean;
  isLoading: boolean;
}

export const queryKey = 'activeSubmissions';

export const useFetchActiveSubmissions = (productGroupId: number | undefined): UseActiveSubmissionsResult => {
  const { data: activeSubmissions = [], isLoading } = useQuery<IProductSubmissionStatusDto[]>(
    [queryKey, productGroupId],
    () => fetchProductSubmissionStatuses(productGroupId!, SubmissionStatus.Active),
    {
      enabled: !!productGroupId,
    },
  );

  return {
    activeSubmissions,
    hasActiveSubmission: activeSubmissions.length > 0,
    isLoading,
  };
};
